module["exports"] = [
  "#{city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/city.js
// module id = 1029
// module chunks = 0